export default __webpack_public_path__ + "static/media/Group 2072.c0d9824a.png";